import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import useDebounce from "../../util/functions/hooks/useDebounce";
interface InputSearchProps {
  id: string;
  style?: object;
  formStyle?: React.CSSProperties;
  value?: string;
  label?: string;
  placeholder?: string;
  onPesquisar?: () => void;
  defaultValue?: string;
  onSearchChange: (search: string) => void;
  exibirIcone?: boolean;
  autoComplete?: string;
}
const InputSearch: React.FC<InputSearchProps> = ({ exibirIcone = true, autoComplete, ...props }) => {
  const [inputValue, setInputValue] = useState(props.value);

  const handleSearchChange = useDebounce(
    (e: React.ChangeEvent<HTMLInputElement>) => props.onSearchChange(e.target.value),
    1000,
    {}
  );

  useEffect(() => {
    setInputValue(props.value);
  }, [props.value]);

  return (
    <>
      {props.label && <span className={"label-input"}> {props.label} </span>}

      <InputGroup className={"input-search"} style={props.style}>
        <Form.Control
          id={props.id}
          style={props.formStyle}
          required
          onChange={(e) => {
            setInputValue(e.target.value);
            handleSearchChange(e as React.ChangeEvent<HTMLInputElement>);
          }}
          value={inputValue}
          type="text"
          className={exibirIcone ? "input-gc input-search-text no-border-radius-right" : "input-gc input-search-text"}
          placeholder={props.placeholder}
          {...(props.value === undefined && props.defaultValue !== undefined ? { defaultValue: props.defaultValue } : {})}
          {...(autoComplete !== undefined ? { autoComplete } : {})}
        />

        {exibirIcone && (
          <InputGroup.Text
            defaultValue={props.defaultValue}
            className={"search-icon"}
            onClick={() => props.onPesquisar && props.onPesquisar()}
          >
            <FaSearch />
          </InputGroup.Text>
        )}
      </InputGroup>
    </>
  );
};

export default InputSearch;
